module.exports = __webpack_public_path__ + "af17f52bd56019052a3ecd2101c9b0ea.svg";